import { render } from "./NewPasswordView.vue?vue&type=template&id=5fdb8788&scoped=true"
import script from "./NewPasswordView.vue?vue&type=script&lang=js"
export * from "./NewPasswordView.vue?vue&type=script&lang=js"

import "./NewPasswordView.vue?vue&type=style&index=0&id=5fdb8788&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fdb8788"]])

export default __exports__